export default {
  'users.title': 'Manage Users',
  'users.userGroup': 'User Groups',
  'users.title.detail': 'DETAIL',
  'users.extraUserFields': 'Extra User Fields',

  'users.form.email': 'Email',
  'users.form.names': 'Names',
  'users.form.lastNames': 'Last Names',
  'users.form.mobilePhone': 'Mobile phone',
  'users.form.role': 'Role',
  'users.form.positionId': 'Position',
  'users.form.userBossId': 'Boss',
  'users.form.accessType': 'Access Type',
  'users.form.isActive': 'Is Active',

  'users.form.selectGroup': 'Select a group',
  'users.form.selectUser': 'Select a user',
  'users.mixed': 'Mixed',
  'users.userandpassword': 'Username and Password',
  'users.office365': 'Office365',
  'users.google': 'Google',

  'users.config.name': 'Name',
  'users.form.selectEnviroment': 'Select the environment',

  'users.userGroupExists': 'Already assigned to that user group',
  'users.environmentExists': 'Already assigned to that environment',
  'users.form.twoFactorEnabled': 'Two-Factor Authentication Enabled?',
  'users.bulk.enableTwoFactor': 'Enable two-factor authentication',
  'users.bulk.disableTwoFactor': 'Disable two-factor authentication',
  'users.selectedElements': 'selected elements',
  'users.selectedElement': 'selected element',
  'users.environmentsTitle': 'User Environments',
  'users.resetPassword.title': 'Reset Password',
  'users.import.restore.confirmCount': 'Do you want to restore the {count} selected users?',
};
